import {reactive, watch} from "vue";
import axios from "axios";
import {toasts} from "@/niftybit";
import router from "@/router";
import eventBus from "@/eventBus";

export default reactive({
    loading: false,
    global: {},
    community: undefined,
    user: undefined,
    getModuleInfo(module) {
        if (this.community?.modules) return this.community.modules[module];
        return undefined;
    },
    async reload() {
        try {
            const response = await axios.get("info");
            const newlyAuthenticated = !this.user && response.data.user;
            this.global = response.data ?? {};
            this.user = this.global.user;
            delete this.global.user;
            if (newlyAuthenticated) eventBus.emit("login");
            eventBus.emit("info.global.loaded");
        } catch (error) {
            toasts.create({
                color: "danger",
                content: "Failed to load info (status " + error.response?.status + ")."
            });
            throw error;
        }
    },
    async reloadCommunity() {
        if (!this.community && !router?.currentRoute?.value.params.communityId) return;
        try {
            const response = await axios.get("communities/" + router.currentRoute.value.params.communityId + "/info");
            this.community = response.data;
        } catch (error) {
            this.community = undefined;
            router.replace("/");
            if (error.response?.status !== 404) {
                toasts.create({
                    color: "danger",
                    content: "Failed to load community info (status " + error.response?.status + ")."
                });
                throw error;
            }
        }
    },
    async initialize() {
        let reloadTimeout = undefined;
        let lastreload = Date.now();
        let reloadCommunityTimeout = undefined;
        let lastReloadCommunity = Date.now();
        eventBus.on("logout", () => {
            this.global = {};
            this.community = undefined;
            this.user = undefined;
            router.push({ name: "authentication" });
            this.reload();
        });
        eventBus.on("socket:event", data => {
            if (data.event === "reloadInfo") {
                if (Date.now() < lastreload + 800) {
                    if (reloadTimeout === undefined)  {
                        reloadTimeout = setTimeout(() => {
                            lastreload = Date.now();
                            this.reload();
                            reloadTimeout = undefined;
                        }, 800);
                    }
                } else {
                    lastreload = Date.now();
                    this.reload();
                }
            } else if (data.event === "reloadCommunityInfo") {
                if (Date.now() < lastReloadCommunity + 800) {
                    if (reloadCommunityTimeout === undefined)  {
                        reloadCommunityTimeout = setTimeout(() => {
                            lastReloadCommunity = Date.now();
                            this.reloadCommunity();
                            reloadCommunityTimeout = undefined;
                        }, 800);
                    }
                } else {
                    lastReloadCommunity = Date.now();
                    this.reloadCommunity();
                }
            }
        });
        await this.reload();
        setInterval(() => {
            if (Date.now() > (lastreload + 30000)) {
                lastreload = Date.now();
                this.reload();
            }
        }, 60000);
        watch(router.currentRoute, route => {
            if (route.params.communityId) {
                if (!this.community || this.community.id !== route.params.communityId) {
                    this.reloadCommunity();
                }
            } else {
                this.community = undefined;
            }
        });
    }
});